export const COMPANY_CONFIRM_PAGE_TITLE = 'Confirm Company Information';

export const COMPANY_CONFIRM_PAGE_DESCRIPTION = 'Please confirm that the information below is correct';
